import { Contact } from '../../../../providers/api/dtos';
import { findDuplicateContact } from '../../../utils/findDuplicateContact';
import { ContactStatus } from '../types';
import { CONTACT_COMPARISON_KEYS } from '../../../constants';
import { hasContactOverwrittenData } from './hasContactOverwrittenData';

export function computeContactStatus(
  isSelected: boolean,
  isContactValid: boolean,
  isConflictResolutionPending: boolean,
  hasImportantChangesWithoutDuplicates: boolean,
  selectedContact?: Contact,
  overwriteContactValues?: Partial<Contact>,
  potentialDuplicates?: Contact[],
): ContactStatus {
  const duplicateContact = findDuplicateContact(overwriteContactValues, potentialDuplicates);

  /** CRITICAL status */
  if (
    isConflictResolutionPending
    && !hasImportantChangesWithoutDuplicates
    && duplicateContact) {
    return 'DUPLICATE';
  }

  if (isSelected && !isContactValid) {
    return 'MISSING_DATA';
  }

  /** WARNING status */
  if (isSelected && !selectedContact?.id) {
    return 'NEW';
  }

  if (
    isConflictResolutionPending
    && !hasImportantChangesWithoutDuplicates
    && potentialDuplicates?.length
    && !duplicateContact
  ) {
    return 'POTENTIAL_DUPLICATE';
  }

  if (
    selectedContact
    && overwriteContactValues
    && (
      (selectedContact.phoneNumber
        && selectedContact.phoneNumber !== overwriteContactValues.phoneNumber)
      || (selectedContact.email
        && selectedContact.email !== overwriteContactValues.email)
    )
  ) {
    return 'OVERWRITE_IMPORTANT_DATA';
  }

  if ((selectedContact && overwriteContactValues) && hasContactOverwrittenData(selectedContact, overwriteContactValues, CONTACT_COMPARISON_KEYS)) {
    return 'OVERWRITE_DATA';
  }

  return 'OK';
}
